module.exports = __webpack_public_path__ + "static/img/11_pro.dfdefcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/11_pro.jpg
// module id = 8VW4
// module chunks = 0